<template>
  <div class="container en024">
    <NoticeBox class="-cancel _mb-sm-40 _mb-md-60 _mt-sm-15 _mt-md-60">
      <NoticeHeader>
        <h1 class="heading">ログインエラー</h1>
      </NoticeHeader>
      <NoticeBody>
        <p class="_mb-50">
          お客さまのご入力されたau ID情報が確認できませんでした。
        </p>

        <p>新規お申し込みのお客さま</p>
        <ListGroup class="-normal _mb-50">
          <ListItem class="-normal"
            >新規お申し込みをご希望のお客さまは、以下「新規お申し込みはこちら」を選択し、お申し込み画面へお進みください。</ListItem
          >
        </ListGroup>

        <p>会員のお客さま</p>
        <ListGroup class="-normal _mb-50">
          <ListItem class="-normal"
            >au
            IDを解約されたお客さま、またはau回線契約を家族間譲渡されたお客さまは、au
            IDでのログインができません。ログインID（メールアドレス）でのログインに変更となります。以下の「ログイン方法のご選択画面はこちら」ボタンを押し、「初回ログイン設定」もしくは「ログインIDでログイン」からお進みください。</ListItem
          >
          <ListItem class="-normal"
            >複数のau
            IDをおまとめされているお客さまは、おまとめいただく以前からご利用いただいているau
            IDでログインしてください。</ListItem
          >
        </ListGroup>
      </NoticeBody>
    </NoticeBox>

    <BtngroupSingle class="_mb-sm-40 _mb-50">
      <BtnMain class="-main -lg" router-name="en001">
        新規お申し込みはこちら
      </BtnMain>
    </BtngroupSingle>

    <BtngroupSingle class="_mb-sm-40">
      <BtnMain class="-main -lg" router-name="ce001">
        ログイン方法のご選択画面はこちら
      </BtnMain>
    </BtngroupSingle>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal -lg" router-name="sv001">
        au PAY スマートローントップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { removeUserSessionCookie } from "@/utils/Auth";
import { setMeta } from "@/utils/Meta";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeBody from "@/components/box/NoticeBody";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";

export default {
  name: "En024",
  components: {
    BtngroupSingle,
    BtnMain,
    ListItem,
    ListGroup,
    NoticeHeader,
    NoticeBody,
    NoticeBox,
  },
  setup() {
    setMeta({
      title: "au PAY スマートローン",
      titleTemplate: null,
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会",
    });
  },
  data() {
    return {};
  },
  mounted() {
    removeUserSessionCookie();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.notice-box {
  &.-cancel {
    .notice-body {
      text-align: left;
    }
  }
}
.important {
  color: $red;
}
</style>
